import React, {useContext, useState} from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Box from "@mui/material/Box";
import {AuthContext} from "../context/authContext";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/core/Alert";

export const WelcomeSplash = () => {

    const {loginWithEmail} = useContext(AuthContext);

    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState(null);
    const [showDialog, setShowDialog] = useState(false);

    const handleClose = ()  => {
        setShowDialog(false);
    }

    return (
        <div className="interactive-cells__title">
            <span>
            Sign in to see stuff
            </span>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    py: 8
                }}
            >
                <TextField
                    required
                    id="outlined-required"
                    label="Email"
                    onChange={(event) => {
                        setEmail(event.target.value);
                    }}
                />
                <TextField
                    id="outlined-password-input"
                    required
                    label="Password"
                    type="password"
                    onChange={(event) => {
                        setPassword(event.target.value);
                    }}
                />
            </Box>

            <Button variant="contained" onClick={async () => {
                console.log('email', email)
                console.log('password', password)
                await loginWithEmail(email, password, () => {

                }, () => {
                    setShowDialog(true);
                });
            }}>Login</Button>
            <Snackbar open={showDialog} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                    Failed to log in
                </Alert>
            </Snackbar>
        </div>
    );
}
